import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface BadgeProps {
  intent?: 'default' | 'brand';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    intent: { default: 'default' }
  },
  setup(__props: any) {

const props = __props as { intent: 'default' | 'brand' };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['badge', props.intent])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})